export default "__VITE_ASSET__DJj8XuZO__";